var map = {
	"./tshirt_00.png": 254,
	"./tshirt_01.png": 831,
	"./tshirt_02.png": 724,
	"./tshirt_03.png": 613,
	"./tshirt_04.png": 738,
	"./tshirt_05.png": 595,
	"./tshirt_06.png": 840,
	"./tshirt_07.png": 969,
	"./tshirt_08.png": 774,
	"./tshirt_09.png": 791,
	"./tshirt_10.png": 425,
	"./tshirt_11.png": 600
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;